import { Directive, ElementRef, Renderer2, HostListener, Input, OnInit } from '@angular/core';
import {ProductsService} from '../services/products.service';

@Directive({
  selector: '[appEditcartradio]'
})
export class EditcartradioDirective {
  isChecked:string;
  prodIdAr:any[] = [];
  storedCart = [];
  verient = [];
  prodQty:number;
  multiSelect:number;
  checkedRadio:string;

  constructor(private renderer:Renderer2, private el:ElementRef, private prodObj:ProductsService) { }

  @HostListener('click') onClick() {
    this.isChecked = this.el.nativeElement.getAttribute('ischecked');

    if (this.isChecked == 'no'){
      this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'yes');
    }else{
      this.prodIdAr['pid'] = this.el.nativeElement.getAttribute('pid');
      this.prodIdAr['optnid'] = this.el.nativeElement.getAttribute('optnid');
      this.prodIdAr['vid'] = this.el.nativeElement.getAttribute('value');
      this.prodIdAr['qty'] = this.el.nativeElement.getAttribute('qty');
      this.prodIdAr['multisel'] = this.el.nativeElement.getAttribute('multisel');

      this.prodObj.varvalid.emit(this.prodIdAr); //Emmiting id array to products service and then receiving in product detail component

      this.renderer.setProperty(this.el.nativeElement, 'checked', false);
      this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'no');
    }
  }

  ngOnInit(){
    var optionname = this.el.nativeElement.getAttribute('optnname');
    var optionid = this.el.nativeElement.getAttribute('optnid');
    var optvaluename = this.el.nativeElement.getAttribute('optnvalue');
    var productId = this.el.nativeElement.getAttribute('pid');
    var optPrice = this.el.nativeElement.getAttribute('price');
    this.prodQty = this.el.nativeElement.getAttribute('qty');
    var optvalueid = this.el.nativeElement.value;
    this.multiSelect = this.el.nativeElement.getAttribute('multisel');
  
  
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));

    this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    if(this.storedCart != null && this.storedCart.length > 0){
      for(var c=0; c < this.storedCart.length; c++){
        if(this.storedCart[c].pId == productId){
            if(this.storedCart[c].varients.length > 0){
              for(var d=0; d < this.storedCart[c].varients.length; d++){
              if(this.storedCart[c].varients[d].optvalueid == optvalueid){

                this.verient['orderitem_id'] = productId;
                this.verient['optionname'] = optionname;
                this.verient['optionid'] = optionid;
                this.verient['optvaluename'] = optvaluename;
                this.verient['optvalueid'] = optvalueid;
                this.verient['ovprice'] = optPrice; 
                
                this.renderer.setProperty(this.el.nativeElement, 'checked', true);
                this.renderer.setAttribute(this.el.nativeElement, 'qty', this.storedCart[c].varients[d].ovqty);

                this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'yes');
                this.prodObj.verientcartArr.emit(this.verient);     

                let optncnt = this.renderer.parentNode(this.el.nativeElement);
                let btnqty = optncnt.querySelector('.optnqty');
                if(btnqty){
                  btnqty.innerText = this.storedCart[c].varients[d].ovqty;
                }
              }
              }
            }
        }
      }
      
    }
  }


} 
